import React__default from 'react';
import classnames from 'classnames';
import { Price } from '@grandvisionhq/common';

const ProductDetailPrice = ({ originalPrice , discountedPrice , currency , customSize , centAmount =true , className ,  })=>{
    if (originalPrice && discountedPrice && originalPrice !== discountedPrice) {
        return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Price, {
            value: discountedPrice,
            currency: currency,
            centAmount: centAmount,
            className: classnames('product-detail-price', className),
            size: customSize !== null && customSize !== void 0 ? customSize : 'large',
            type: "discount"
        }), /*#__PURE__*/ React__default.createElement(Price, {
            value: originalPrice,
            currency: currency,
            centAmount: centAmount,
            className: classnames('product-detail-price', className),
            size: customSize !== null && customSize !== void 0 ? customSize : 'large',
            type: "strikethrough"
        }));
    }
    return /*#__PURE__*/ React__default.createElement(Price, {
        value: originalPrice,
        currency: currency,
        centAmount: centAmount,
        size: customSize !== null && customSize !== void 0 ? customSize : 'large',
        className: "product-detail-price"
    });
};

export { ProductDetailPrice };
//# sourceMappingURL=ProductDetailPrice.js.map
